<template>
  <div class="header">
    <img src="@/assets/img/title_img.png" class="title-img" alt />
    <p class="title" v-html="title"></p>
  </div>
</template>

<script>
/* eslint-disable no-console */

export default {
  name: "Header",
  components: {},
  props: ["title"],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.header {
  flex: 0 0 8rem;
}
</style>
